module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__overlay"
  }, [_c('div', {
    staticClass: "modal__close--desktop modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span'), _c('span')])]), _c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__close--mobile modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('Icon', {
    staticClass: "modal__header-icon",
    attrs: {
      "name": "logo-white"
    }
  }), (_vm.$store.state.modalContent == 0) ? _c('div', {
    staticClass: "modal__header-title"
  }, [_vm._v("Contact Us")]) : _vm._e(), (_vm.$store.state.modalContent == 1) ? _c('div', {
    staticClass: "modal__header-title"
  }, [_vm._v("Patient Referral    ")]) : _vm._e()], 1), (_vm.$store.state.modalContent == 0) ? _c('div', {
    staticClass: "modal__form-container"
  }, [_c('Form')], 1) : _vm._e(), (_vm.$store.state.modalContent == 1) ? _c('div', {
    staticClass: "modal__form-container"
  }, [_c('ReferForm')], 1) : _vm._e(), (_vm.$store.state.modalContent == 2) ? _c('div', {
    staticClass: "modal__form-container"
  }, [_vm._m(0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule_modelouter"
  }, [_c('div', {
    staticClass: "btn_inner_schedule"
  }, [_c('a', {
    attrs: {
      "href": "https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=psnnsi",
      "target": "_blank"
    }
  }, [_vm._v("Schedule a new patient consult for adult Braces/Aligners                  ")])]), _c('div', {
    staticClass: "btn_inner_schedule"
  }, [_c('a', {
    attrs: {
      "href": "https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=sbsxfy",
      "target": "_blank"
    }
  }, [_vm._v("Schedule a new patient consult for Kids Braces")])]), _c('br'), _c('p', {
    staticClass: "modal__text"
  }, [_c('span', [_vm._v("For new patient pediatric dental appointments please call ")]), _c('br')]), _c('div', {
    staticClass: "btn_inner_schedule"
  }, [_c('a', {
    attrs: {
      "href": "tel:630-980-8800"
    }
  }, [_vm._v("(630)980-8800")])]), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b58be2c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal.pug
// module id = 691
// module chunks = 1